import { IsBoolean } from "class-validator";

export class ResetEnvironmentResult {
    @IsBoolean()
    success: boolean;
}